/**
 * Regex patterns and constants for artefact detection
 */

export const DETECTION_PATTERNS = {
  // Code block patterns
  CODE_BLOCK: /```(\w+)?\s*\n([\s\S]*?)```/g,
  INLINE_CODE: /`([^`]+)`/g,

  // Document structure patterns
  HEADINGS: /^#{1,6}\s+.+$/m,
  UNORDERED_LISTS: /^[\s]*[-*+]\s+.+$/m,
  ORDERED_LISTS: /^[\s]*\d+\.\s+.+$/m,
  EMPHASIS_BOLD: /\*\*.+?\*\*/,
  EMPHASIS_ITALIC: /\*.+?\*/,
  LINKS: /\[.+?\]\(.+?\)/,

  // Table patterns
  JSON_ARRAY: /^\s*\[\s*\{[\s\S]*?\}\s*\]\s*$/m,
  CSV_LIKE: /^[^,\n]+,[^,\n]+(?:,[^,\n]*)*$/m,

  // HTML patterns
  HTML_TAGS: /<\/?[a-z][\s\S]*>/i,
  HTML_DOCUMENT: /<!DOCTYPE\s+html/i,
  STYLE_TAGS: /<style[\s\S]*?<\/style>/gi,
} as const;

export const LANGUAGE_ALIASES = {
  js: "javascript",
  ts: "typescript",
  py: "python",
  rb: "ruby",
  sh: "bash",
  yml: "yaml",
  md: "markdown",
} as const;
